import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {AlertService} from "./alert.service";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  errorKey: string;
  errorCode: number;

  constructor(private router: Router,
              private translate: TranslateService,
              private alertService: AlertService) {
  }

  goToErrorPage(errorMessageKey: string, errorCode: number) {
    this.errorKey = errorMessageKey;
    this.errorCode = errorCode;
    this.router.navigate(['error']);
  }

  showErrorAlert(errorMessageKey: string, params?: any) {
    this.translate.get(errorMessageKey, params).subscribe((translatedMessage: string) => {
      this.alertService.error(translatedMessage);
    });
  }

  showErrorAlertAndNavigate(errorMessageKey: string, path: string[], params?: any) {
    this.translate.get(errorMessageKey, params).subscribe((translatedMessage: string) => {
      this.alertService.error(translatedMessage);
      this.router.navigate(path);
    });
  }
}
